export const HOME_PAGE_ROUTE = '/';
export const RUNNER_HELP_PAGE_ROUTE =
  'https://liively.my.canva.site/liively-runner-assist';
